<div ngbDropdown container="body" class="d-inline-block">
    <button style="min-width: 100px" ngbDropdownToggle class="btn m-btn--pill btn-sm" [ngClass]="selectedStatus?.class">
        {{ selectedStatus?.title }}
    </button>
    <div ngbDropdownMenu>
        <button *ngFor="let item of list | ddFilter: selected" (click)="selectionChange(item)" ngbDropdownItem class="mf-cursor-pointer">
            {{ item?.title }}
        </button>
    </div>
</div>
